import React from "react";
import { useNavigate } from "react-router-dom";
import "./forbidden.scss";

const Forbidden = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    // Clear all localStorage
    localStorage.clear();
    // Navigate to root route (login page)
    navigate("/");
  };

  return (
    <div className="forbidden-container">
      <div className="forbidden-background">
        {/* Decorative blob shapes */}
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
        <div className="blob blob-4"></div>
        
        {/* Decorative elements */}
        <div className="decorative-star star-1">★</div>
        <div className="decorative-star star-2">★</div>
        <div className="decorative-star star-3">★</div>
        <div className="decorative-circle circle-1"></div>
        <div className="decorative-circle circle-2"></div>
        <div className="decorative-circle circle-3"></div>
        <div className="decorative-dot dot-1"></div>
        <div className="decorative-dot dot-2"></div>
        <div className="decorative-dot dot-3"></div>
        <div className="decorative-dot dot-4"></div>
      </div>
      
      <div className="forbidden-content">
        <div className="forbidden-number">
          <span className="number-4">4</span>
          <div className="number-0-circle">
            <div className="minus-sign"></div>
          </div>
          <span className="number-3">3</span>
        </div>
        
        <h1 className="forbidden-heading">Access denied...</h1>
        <p className="forbidden-message">
          You don't have permission to access this page.
        </p>

        <button
          onClick={handleGoHome}
          className="forbidden-btn-homepage"
        >
          Go to Login
        </button>
      </div>
    </div>
  );
};

export default Forbidden;

